import { io } from 'socket.io-client';

// "undefined" means the URL will be computed from the `window.location` object
// const URL = `${process.env.REACT_APP_API_ENDPOINT}:3001`;
const URL = 'https://api.dvdyatii.com:3001/'

export const socket = io(URL);